var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { loginApi } from 'apis/login';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
/**
 * A hook that resolves the auth data from the dixa login page params. When the
 * user on that page page navigates to dixa, the token and organization id gets
 * extracted from the params and passed to our login api endpoint that exchanges
 * these to auth data.
 */
export const useAuthMagicLink = () => {
    const dispatch = useAppDispatch();
    const { params: { loginToken, orgId: organizationId }, unsetParams, } = useAppSearchParams('/');
    /**
     * Gets the auth data through the login api endpoint for exchanging the login
     * token and organization id to the auth data.
     */
    const getAuthData = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!loginToken || !organizationId) {
            return Promise.reject();
        }
        unsetParams(['refreshToken', 'orgId', 'loginToken']);
        const { data: authData } = yield dispatch(loginApi.endpoints.createAppLogin.initiate({
            loginToken,
            organizationId,
        })).unwrap();
        return { type: 'magicLink', asyncStatus: 'fulfilled', authData };
    }), [dispatch, loginToken, organizationId, unsetParams]);
    return getAuthData;
};
